var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8456 15.0122L9.57106 16.2867C7.95346 17.9043 5.3308 17.9043 3.7132 16.2867V16.2867C2.0956 14.6691 2.0956 12.0465 3.7132 10.4288L5.37479 8.76726C6.15619 7.98586 7.216 7.54688 8.32107 7.54688C9.42614 7.54688 10.4859 7.98586 11.2674 8.76726",
    stroke: "#6B758B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15417 4.98773L10.4287 3.7132C12.0463 2.0956 14.669 2.0956 16.2866 3.7132V3.7132C17.9042 5.3308 17.9042 7.95346 16.2866 9.57106L14.625 11.2326C12.9978 12.8598 10.3596 12.8598 8.73242 11.2326",
    stroke: "#6B758B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.884eec1839811dbcc56844b959f7adc6.svg";
export { ForwardRef as ReactComponent };